import React, { useContext } from 'react';
import { Avatar, Typography } from '@common-ui/ui';
import { Document } from './ContextDocument';
import { PageContext, Page } from './ContextPage';
import { Section } from './ContextSection';
import './styles.css';

export function Header({ info }) {
  const { site_id, company, company_logo } = info || {};

  const companyData = {
    logo: company_logo,
    site_id: site_id || '',
    address: '55555 Roda St | Ontario, CA USA',
    phone: '555-555-5555',
    email: company ? `info@${company}.com` : 'info@company.com',
  };

  const avatarStyle = {
    height: '100%',
    width: 'auto',
    maxWidth: '100%',
    borderRadius: '0%',
    objectFit: 'contain',
  };

  return (
    <div className="header-container">
      {companyData.logo && (
        <div className="header-logo-container">
          <Avatar
            className="header-logo"
            src={`${companyData.logo}`}
            alt="Company Logo"
            style={avatarStyle}
          />
        </div>
      )}
      <div className="header-container-info">
        <div className="header-company-info">
          <Typography variant="h6" className="header-company-name">
            Location:
          </Typography>
          <Typography variant="h6" className="header-company-address">
            {companyData.site_id || ''}
          </Typography>
        </div>
      </div>
    </div>
  );
}

export function Footer({ info = {} }) {
  const { pageNumber } = useContext(PageContext);

  const { report_name = '', company = '' } = info;

  const today = new Date();
  const year = today.getFullYear();

  const footerData = {
    name: `${report_name}`,
    date: today.toISOString().substring(0, 10),
    copyright: `Copyright ${year} ${company}`,
    page: `Page | ${pageNumber}`,
  };

  return (
    <div className="footer-container">
      <div className="footer-container-left">
        <Typography variant="caption">{footerData.copyright}</Typography>
      </div>

      <div className="footer-container-middle">
        {footerData.name !== '' && <Typography variant="h6">{footerData.name}</Typography>}
        <Typography variant="caption">{footerData.date}</Typography>
      </div>

      <div className="footer-container-right">
        <Typography variant="caption">{footerData.page}</Typography>
      </div>
    </div>
  );
}

export default { Document, Page, Section, Header, Footer };
